import type { FC } from "react";

import { EmptyState } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

interface ISidePanelEmptyStateProps {
    title: string;
    subtitle?: string;
}

export const SidePanelEmptyState: FC<ISidePanelEmptyStateProps> = ({ title, subtitle }) => {
    return (
        <Flex
            flex="1"
            alignItems="center"
            justifyContent="center"
        >
            <EmptyState
                title={title}
                subtitle={subtitle}
            />
        </Flex>
    );
};
